import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  NotificationModalComponent, type NotificationModalProps,
} from './notificationModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Notification: NotificationModalProps;
  }
}

modalRenderer.register('Notification', NotificationModalComponent);
